/* ==========================================================================
   discount-display.js  —  keeps the discounted price correct on variant change
   --------------------------------------------------------------------------
   The Broadcast theme rewrites the product price every time a variant is
   selected (ProductForm.updateProductPrices) and then fires a bubbling
   'theme:variant:change' event on the product container. We listen for that
   event AFTER the theme has written the base price and re-apply the discount,
   reading the resolved percentage + compare mode straight off the DOM
   (rendered server-side by discount-calc.liquid into [data-price-wrapper]).

   Cart is intentionally untouched — Shopify owns cart/checkout pricing.

   This file mirrors snippets/discount-calc.liquid. Keep the math in sync.
   ========================================================================== */
(function () {
  'use strict';

  function formatMoney(cents) {
    try {
      return window.themeVendor.themeCurrency.formatMoney(cents, window.theme.moneyFormat);
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  }

  // Mirror of the Liquid engine. compareMode: 'original' | 'keep'
  function compute(priceCents, compareCents, percent, compareMode) {
    // Shopify floors the per-line percentage discount to the cent (not round
    // half-up), so we floor here too to match checkout and the Liquid engine.
    var discount = Math.floor((priceCents * percent) / 100);
    var finalPrice = priceCents - discount;
    if (finalPrice < 0) finalPrice = 0;

    var comparePrice = 0;
    var compareShow = false;

    if (compareMode === 'keep') {
      // strict: strike the compare-at (real) price only
      if (compareCents && compareCents > finalPrice) {
        comparePrice = compareCents;
        compareShow = true;
      }
    } else {
      // default: strike the compare-at (real) price; fall back to the
      // pre-discount price when the product has no compare-at.
      if (compareCents && compareCents > finalPrice) {
        comparePrice = compareCents;
      } else {
        comparePrice = priceCents;
      }
      compareShow = true;
    }

    return { finalPrice: finalPrice, comparePrice: comparePrice, compareShow: compareShow };
  }

  function applyToWrapper(wrap, variant) {
    var percent = parseFloat(wrap.getAttribute('data-discount-percent') || '0');
    // No discount for this product → leave the theme's native output alone.
    if (!percent || percent <= 0) return;

    var compareMode = wrap.getAttribute('data-discount-compare-mode') || 'original';

    var priceEl = wrap.querySelector('[data-product-price]');
    if (!priceEl) return;
    var compareEl = wrap.querySelector('[data-compare-price]');
    var compareText = wrap.querySelector('[data-compare-text]');

    var r = compute(variant.price, variant.compare_at_price, percent, compareMode);

    priceEl.innerHTML =
      r.finalPrice === 0 ? (window.theme.strings.free || formatMoney(0)) : formatMoney(r.finalPrice);
    priceEl.classList.add('product__price--sale');

    if (compareEl) {
      if (r.compareShow) {
        compareEl.innerHTML = formatMoney(r.comparePrice);
        compareEl.classList.remove('hidden');
        if (compareText) compareText.classList.remove('hidden');
      } else {
        compareEl.innerHTML = '';
        compareEl.classList.add('hidden');
        if (compareText) compareText.classList.add('hidden');
      }
    }
  }

  function onVariantChange(event) {
    var container = event.target;
    var variant = event.detail && event.detail.variant;
    if (!container || !variant || typeof variant.price === 'undefined') return;

    var wrappers = container.querySelectorAll('[data-price-wrapper]');
    for (var i = 0; i < wrappers.length; i++) {
      applyToWrapper(wrappers[i], variant);
    }
  }

  // Bubbles up to document, so a single listener covers the PDP and the
  // quick-add modal (and any future product section).
  document.addEventListener('theme:variant:change', onVariantChange);
})();
